import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, Routes, Route } from 'react-router-dom';
import { usePostHog } from 'posthog-js/react';

import getConfig from "../../config";
import HomePage from "../../components/HomePage/HomePage";
import NotFound from "../../components/NotFound/NotFound";
import AttachmentsHandler from "../AttachmentsHandler/AttachmentsHandler";
import ReportHandler from "../ReportHandler/ReportHandler";
import ReportKanban from "../ReportKanban/ReportKanban";
import Notification from "../../components/Notification/Notification";
import { getAuthUserInfo } from '../../utils/data.request';
import ToastComponent from "../../components/ToastComponent/ToastComponent";
import { apiGetUserPosthogRole } from "../../models/userDataModel/userDataAPI";

import "./ReportWizard.scss";

const ReportWizard = () => {
  const dispatch = useDispatch(); // this hook gives us dispatch method
  const location = useLocation();
  const user = useSelector(state => state.userData.user);
  const posthog = usePostHog()
  const permission = useSelector(state => state.userData.posthog);
  const config = getConfig();

  useEffect(() => {
    dispatch(getAuthUserInfo());

  }, [dispatch]);

  useEffect(() => {
    if (user && user.email) {
      if (localStorage.getItem("url") !== null && localStorage.getItem("url") !== location.pathname) {
        window.location.href = localStorage.getItem("url");
      } else {
        localStorage.removeItem("url");
      }
      //call permision api to get the posthog role for logging
      dispatch(apiGetUserPosthogRole());
    }
  }, [user, location, dispatch]);

  // call the posthog capture method to log the weather user is developer/bussines
  useEffect(() => {
    if (!config.Local) {
      permission && posthog.register(permission.permission)
    }
  }, [permission, posthog, config]);

  return user && (
    <div className="App">
      <Notification />
      <ToastComponent />
      <Routes >
        <Route path="/" element={<HomePage />} />
        <Route path="/kanban" element={<ReportKanban />} />
        <Route path="/AttachmentsHandler/:reportName/:fileName" element={<AttachmentsHandler />} />
        <Route path="/ReportHandler/:templateName/:reportName" element={<ReportHandler />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  )

};
export default ReportWizard;
